var scrollUpBtn = $('#scrollUpBtn');

$(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
        scrollUpBtn.addClass('active');
    } else {
        scrollUpBtn.removeClass('active');
    }
});
    
$(document).ready(function () {
    scrollUpBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, '300');
    });
});